import { createContext, useContext, useEffect, useState } from 'react'
import { useGame, useModalBox } from '.'
import { makeLoadTermBySlug } from '../../main/usecases/terms/terms-factory'
import Cookie from 'js-cookie'

type TermsContextProps = {
  handleToggleTermsModal: () => void;
  handleTogglePrivacyPolicyModal: () => void;
}

const TermsContext = createContext<TermsContextProps>({} as TermsContextProps)

export const TermsProvider = ({ children }: any) => {
  const { game } = useGame()
  const [titleUseTerms, setTitleUseTerms] = useState<string>('')
  const [contentUseTerms, setContentUseTerms] = useState<string>('')
  const [titlePrivacyAndPolicy, setTitlePrivacyAndPolicy] = useState<string>('')
  const [contentPrivacyAndPolicy, setContentPrivacyAndPolicy] = useState<string>('')

  const { modalBox } = useModalBox()

  function handleToggleTermsModal () {
    modalBox(contentUseTerms, titleUseTerms)
  }

  function handleTogglePrivacyPolicyModal () {
    modalBox(contentPrivacyAndPolicy, titlePrivacyAndPolicy)
  }

  function buildTermsEndpoint (language: string) {
    switch (language) {
      case 'portuguese':
        return '/termos-de-uso'
      case 'spanish':
        return '/terminos-de-uso'
      default:
        return '/terms-of-use'
    }
  }

  function buildPolicyPrivacyEndpoint (language: string) {
    switch (language) {
      case 'portuguese':
        return '/politica-de-privacidade'
      case 'spanish':
        return '/politica-de-privacidad'
      default:
        return '/privacy-policy'
    }
  }

  async function loadTerms () {
    try {
      const teamUUId = Cookie.get('teamUUId') ?? false
      const gameUUId = Cookie.get('gameUUId') ?? false

      if (teamUUId || gameUUId) {
        console.log('wait sso signup')
      } else {
        const termsEndpoint = `${buildTermsEndpoint(game?.language)}?game=${game?.uuid}`
        const policyPrivacyEndpoint = `${buildPolicyPrivacyEndpoint(game?.language)}?game=${game?.uuid}`
        const useTermsData = await makeLoadTermBySlug().load(termsEndpoint)
        const policyPrivacyData = await makeLoadTermBySlug().load(policyPrivacyEndpoint)
        setTitleUseTerms(useTermsData.title)
        setContentUseTerms(useTermsData.content)
        setTitlePrivacyAndPolicy(policyPrivacyData.title)
        setContentPrivacyAndPolicy(policyPrivacyData.content)
      }
    } catch (e) {
      console.error(e)
    }
  }

  useEffect(() => {
    (async () => {
      await loadTerms()
    })()
  }, [game?.language])

  return (
    <TermsContext.Provider value={{
      handleToggleTermsModal,
      handleTogglePrivacyPolicyModal
    }}
    >
      {children}
    </TermsContext.Provider>
  )
}

export const useTerms = () => {
  const context = useContext(TermsContext)

  if (!context) throw new Error('useTerms must be used within a provider TermsProvider')

  return { ...context }
}
